<template>
  <div class="search search_result_wrap">
    <div class="searchtop">
      <van-icon name="arrow-left" @click="back" />
      <div class="searchtop_text">搜索</div>
      <van-icon name="close" />
    </div>
    <div class="search_content">
      <div class="search_content_left">
        <span class="icon_search"></span>
        <input
          type="text"
          class="search_con"
          ref="search_con"
          placeholder="搜索此社区的内容"
        />
        <span class="icon_close" @click="clearSearch"></span>
      </div>
      <p @click="searchClick">搜索</p>
    </div>
    <div class="hot_srarch" v-if="searchResultFlag">
      <h2 v-show="hotWordsList.length != 0">热搜词</h2>
      <div class="hot_words_list" v-show="hotWordsList.length != 0">
        <p
          v-for="item in hotWordsList"
          :key="item"
          @click="hotWordsClick(item)"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <div class="search_result">
      <card v-for="item in searchResult" :key="item.id" :cardData="item"></card>
    </div>
  </div>
</template>
<script>
import get from "@/api/get";
import _ from "lodash";
import qs from "qs";
import card from "../../card";
import { Search, Toast } from "vant";
export default {
  name: "search",
  components: { card },
  data() {
    return {
      hotWordsList: [],
      searchHistory: [],
      searchResult: [],
      searchResultFlag: false,
    };
  },
  mounted() {
    this.getHotWords();
    this.querySearchHistory();
    this.searchResult = this.$route.query.searchResult;
  },
  methods: {
    back() {
      this.$emit("searchClick", false);
    },
    getHotWords() {
      get.getHotWords().then((res) => {
        if (res.data.code == 0) {
          this.hotWordsList = res.data.data;
        } else {
        }
      });
    },
    hotWordsClick(item) {
      this.$refs.search_con.value = item;
      this.searchClick();
    },
    querySearchHistory() {
      if (localStorage.getItem("searchHistory")) {
        this.historyFlag = true;
        this.searchHistory = JSON.parse(localStorage.getItem("searchHistory"));
      }
    },
    searchClick() {
      let searchInfo = {
        keyword: this.$refs.search_con.value,
        pageNo: 1,
        pagecount: 10,
        datatype: 1,
      };
      this.searchHistory.push(this.$refs.search_con.value);
      this.searchHistory = Array.from(new Set(this.searchHistory));
      localStorage.setItem("searchHistory", JSON.stringify(this.searchHistory));
      get.getSearchData(qs.stringify(searchInfo)).then((res) => {
        this.searchResultFlag = false;
        if (res.data.data.code == 0) {
          this.searchResult = res.data.data.data;
        } else {
        }
        if (!this.searchResult.length) {
          Toast("暂无内容");
          this.searchResultFlag = true;
        }
      });
    },
    clearSearch() {
      this.$refs.search_con.value = "";
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
</style>